import React from "react"

function Errormsg(){

     return  <div>
                <h1>Error</h1>
            </div>
}

export default Errormsg



// WEBPACK FOOTER //
// ./src/components/error404.js